import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import '../../../shared/components/navigable';
import {FormControl, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';

@Component({
    selector: 'app-searchbar',
    template: `
        <form class="searchbar" [formGroup]="form" (ngSubmit)="submit()">
            <mat-form-field [ngClass]="{'active': form.get('searchText').value.length > 0 }" class="searchbar-form-field">
                <input appIosAutoFillFix type="text" matInput formControlName="searchText"/>
                <button matSuffix class="search" mat-icon-button>
                    <mat-icon [svgIcon]="'hering-search'">
                    </mat-icon>
                </button>
            </mat-form-field>
        </form>
    `,
    styleUrls: ['./searchbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation : ViewEncapsulation.None
})
export class SerachbarComponent {

    form: FormGroup = new FormGroup({
        searchText: new FormControl('')
    });

    constructor(private router: Router) {
    }

    submit() {
        const searchText = this.form.get('searchText').value;
        this.router.navigate(['products', 'search', encodeURIComponent(searchText)]);
    }

}
